module.exports = __webpack_public_path__ + "static/media/A7.44ab26a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/image_articles/A7.png
// module id = 2301
// module chunks = 0